import React from 'react';
import './CSS/About.css';
import './CSS/Header.css';
import { Link } from 'react-router-dom';

const ServiceHero = ({ service }) => {

    const buttonName = service.page_title.includes('Servicing') ? 'Book a Service' : service.page_title.includes('Repair') ? 'Book a Repair' : service.page_title.includes('Support') ? 'Book a Service' : service.page_title.includes('Coaching') ? 'Schedule a Session' : 'Book a Service';

    return (
        <section
            className="about-hero-section"
            style={{ backgroundImage: `url(${service.banner_image})` }}
        >
            <div className="container">
                <div className="about-hero-content">
                    <h1 className="about-hero-title" style={{ color: 'white' }}>
                        {service.page_title || service.title}
                    </h1>
                    <p className="about-hero-subtitle" style={{ color: 'white' }}>
                        {service.full_description || service.short_description}
                    </p>
                    <Link
                        style={{ backgroundColor: 'var(--primary-color)', color: 'var(--white)', marginTop: '20px' }}
                        to="/contact"
                        className="btn"
                    > {buttonName}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ServiceHero;
